import { mdiBellBadgeOutline, mdiBellOutline } from '@mdi/js';
import { buttonMediumSize } from '../../styles/theme/theme';
import { Dropdown } from '@components/Dropdown/Dropdown';
import { useTheme } from '@mui/material';
import { useGetAlerts } from '@services/api/alerts/alerts';
import { Alerts } from '@components/AlertCenter/AlertRows/Alerts';
import { Empty } from '@components/Empty/Empty';
import EmptyTemplateImage from '@assets/svg/EmptyComponentIcons/EmptyTemplate.svg';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { useQueryParamsModal } from '@utils/navigation/queryParamsNavigation';

export const AlertCenter = () => {
  const {
    translate,
    translations: {
      alertCenter: { noAlerts },
    },
  } = useTranslations();
  const { isModalOpen: isFilterDropdownOpen, toggleModalOpen: toggleIsFilterDropdownOpen } =
    useQueryParamsModal(`alerts`);
  const { alerts } = useGetAlerts();

  const theme = useTheme();

  return (
    <Dropdown
      iconButtonIconPath={alerts?.length ? mdiBellBadgeOutline : mdiBellOutline}
      isDropdownOpen={isFilterDropdownOpen}
      toggleIsDropdownOpen={toggleIsFilterDropdownOpen}
      placeIconAfterText={true}
      styles={{
        padding: 1.5,
        minWidth: buttonMediumSize,
        height: buttonMediumSize,
        minHeight: buttonMediumSize,
        '& svg': {
          color: theme.palette.text.primary,
        },
      }}
      transformLeft
    >
      {alerts?.length ? (
        <Alerts alerts={alerts ?? []} />
      ) : (
        <Empty description={translate(noAlerts)} icon={EmptyTemplateImage} />
      )}
    </Dropdown>
  );
};
